// 'use strict';

var util = require('./property-util');
var arrayUtil = require('./array-util');
var messageDiscriptors = require('./messageDiscriptors');

module.exports = {
    /**
     Because the AmChart library prefers one object with all 'selected' properties
     we need to create our own objects with every selected property put into it.
     we order them by time and for each message, we try to populate it with date of objects with identical timestamps.
     if this is not possible, we reuse the data of the previous message.
     To be able to easily distinguish different sets of data eg: mar, virtual user etc we stored them in a map. The key
     is a unique key that identifies the data.
     **/

// not used anymore??
    mapToAmDataProviderArray: function (mappedDatabyType) {
        var chartData = [];
        var latestCompleteObject = {};
        var dataOrderedByIdOrderedByTime = new Map();
        var intervals = new Map();

        //for each type of message, map his dataset by his timestamp so the code can easily look
        //for data that has the same timestamp.
        mappedDatabyType.forEach(function (value, key, map) {

            var dataOrderedByTime = new Map();
            var interval = 0;
            var savedInterval = false;
            value.forEach(function (data) {
                dataOrderedByTime.set(data.timestamp.getTime(), data);
                if (!savedInterval) {
                    interval = data.interval;
                    savedInterval = true;
                }
            });

            dataOrderedByIdOrderedByTime.set(key, dataOrderedByTime);
            intervals.set(key, interval);
        });

        var finalMap = new Map();


        //Each message type has a map which linked timestamp to a message value
        dataOrderedByIdOrderedByTime.forEach(function (valuesPerMessageType, messageType, map) {
            //define which other properties your current message needs.
            var otherChartMessageTypes = arrayUtil.getOtherKeys(map, messageType);

            //For each value of this message type, find other messages with the same timestamp and
            //and fill your object with the needed properties.
            valuesPerMessageType.forEach(function (message, timestamp, messageTimeMap) {

                if (finalMap.has(timestamp)) {
                    return;
                }

                var object = {};

                object = util.copyProperties(message, object);
                if (util.isDefined(object.interval)) {
                    delete object.interval;
                }
                otherChartMessageTypes.forEach(function (type) {
                    var otherChartMessageMap = map.get(type);
                    var timestampsOfType = getKeys(otherChartMessageMap);
                    var interval = intervals.get(type);
                    if (util.isDefined(interval)) {
                        var equalOrLowerTimestamp = arrayUtil.equalOrLowerWithInterval(timestampsOfType, object.timestamp, interval);
                    } else {
                        var equalOrLowerTimestamp = arrayUtil.equalOrLower(timestampsOfType, object.timestamp);
                    }

                    if (util.isDefined(equalOrLowerTimestamp)) {
                        var foundMessageOfType = map.get(type).get(equalOrLowerTimestamp);
                        object = util.copyProperties(foundMessageOfType, object);
                        if (util.isDefined(object.interval)) {
                            delete object.interval;
                        }
                        object.timestamp = new Date(timestamp);
                    }

                });
                finalMap.set(timestamp, object);
            });

        });

        chartData = arrayUtil.getMapValueAsList(finalMap);
        chartData.sort(sortByTimestampASC);

        return chartData;
    },

    getRandomColor: function () {
        var letters = '0123456789ABCDEF'.split('');
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    },

    getSemiRandomColor: function (avoidColors) {
        var colors = module.exports.getSemiRandomColorArray();

        if (util.isDefined(avoidColors)) {
            colors = $(colors).not(avoidColors).get();
        }
        var size = colors.length;

        var colorIndex = Math.floor(Math.random() * size);
        return colors[colorIndex];

    },

    getSemiRandomColorArray: function () {
        //return ["aqua", "blue", "fuchsia", "gray", "green", "lime", "maroon", "navy", "olive", "orange", "purple", "silver", "teal", "CornflowerBlue", "DarkOrchid", "SteelBlue", "FireBrick", "MediumAquaMarine", "GreenYellow", "ForestGreen", "Indigo", "LawnGreen", "LightSeaGreen", "MediumPurple", "RoyalBlue", "RebeccaPurple", "Sienna", "Turquoise", "MediumVioletRed"];
        return [
            '#7cb5ec', '#434348', '#90ed7d', '#f7a35c',
            '#8085e9', '#f15c80', '#e4d354', '#2b908f',
            '#f45b5b', '#91e8e1', "#2EB398", "#FA7252",
            "#68A0A5", "#EBA068", "#55C9A6", "#EA7882",
            "#428BCA", "#B4A1DD", "#A8553A", "#EE682F",
            "#7d6a92", "#3AA9CF", "#ca7a0b", "#6c0098",
            "#ce8ea7", "#e040dd", "#fd5eaa", "#10b5af",
            "#70f1bf", "#1cb988", "#3665c5", "#a14eae",
            "#cfa93c", "#bec017", "#31371d", "#c221a3",
            "#0474a5", "#6100a5", "#cc926e", "#82c4d0",
            "#aafc88", "#dc929c", "#ed4e2b", "#f75b9c",
            "#8dc77a", "#350b84", "#dc03c0", "#2a4911",
            "#0b6edc", "#b0065c", "#b24400", "#b30e72",
            "#3437dd", "#6a0e1b", "#ab7de9", "#dc3a81",
            "#d86f3d", "#d9df14", "#e17560", "#a72ac3",
            "#031e93", "#47bcff",
        ];
    },

    createNewGraph: function (axis, color, title, valueField, unit) {
        var graph = {
            bullet: 'round',
            bulletBorderThickness: 1,
            hideBulletsCount: 30,
            title: "default",
            fillAlphas: 0,
            lineColor: "black"
        };

        graph.valueField = valueField;

        graph.valueAxis = axis;

        graph.lineColor = color || "black";

        graph.title = title || "No Title";

        graph.balloonText = '[[value]] ' + unit;

        return graph;
    },

    createGraph: function (axis, metaData, title, valueField, property) {
        var graph = {
            bulletBorderThickness: 1,
            hideBulletsCount: 30,
            title: "default",
            fillAlphas: 0,
            lineColor: "black"
        };
        if (!util.isDefined(metaData)) {
            var metaData = {};
        }
        if (util.isDefined(property) && util.isDefined(property.dashLength)) {
            graph.dashLength = property.dashLength;
        } else {
            graph.dashLength = 0;
        }

        if (util.isDefined(property) && util.isDefined(property.bullet)) {
            graph.bullet = property.bullet;
        } else {
            graph.bullet = "round";
        }
        if (util.isDefined(property) && util.isDefined(property.color)) {
            graph.lineColor = property.color;
        } else {
            graph.lineColor = metaData.color || "black";
        }

        graph.valueField = valueField;

        graph.valueAxis = axis;

        graph.title = title || "No Title";

        if (util.isDefined(metaData.balloonFunction)) {
            graph.balloonFunction = metaData.balloonFunction;
        }

        return graph;
    },


    getDateFormats: function () {
        return [
            {period: 'fff', format: 'JJ:NN:SS'},
            {period: 'ss', format: 'JJ:NN:SS'},
            {period: 'mm', format: 'JJ:NN'},
            {period: 'hh', format: 'JJ:NN'},
            {period: 'DD', format: 'MMM DD'},
            {period: 'WW', format: 'MMM DD'},
            {period: 'MM', format: 'MMM'},
            {period: 'YYYY', format: 'YYYY'}
        ];
    },

    createNewValueAxis: function (axeId, axisColor, position, offset, unit) {
        var axis = {
            "axisThickness": 2,
            "gridAlpha": 0,
            "axisAlpha": 1
        };

        unit = util.isDefined(unit) ? unit : '';

        if (!util.isDefined(axeId)) {
            return;
        } else {
            axis.id = axeId;
        }

        axis.position = position || 'left';
        axis.axisColor = axisColor || 'black';
        axis.offset = offset || 0;
        axis.unit = unit;

        return axis;
    },

    createValueAxis: function (axeId, presentOffset, metaData) {
        var axis = {
            "axisThickness": 2,
            "gridAlpha": 0,
            "axisAlpha": 1
        };
        if (!util.isDefined(axeId)) {
            return;
        } else {
            axis.id = axeId;
        }
        if (!util.isDefined(metaData)) {
            metaData = {};
        }
        axis.position = metaData.position || 'left';
        axis.axisColor = metaData.color || 'black';
        if (util.isDefined(presentOffset)) {
            if (presentOffset == 0) {
                axis.offset = 0
            } else {
                axis.offset = util.isDefined(metaData.offset) ? presentOffset + metaData.offset : presentOffset + 50;
            }
        }

        axis.unit = metaData.unit || '';

        if (util.isDefined(metaData.labelsEnabled)) {
            axis.labelsEnabled = metaData.labelsEnabled;
        } else {
            axis.labelsEnabled = true;
        }

        if (util.isDefined(metaData.labelFunction)) {
            axis.labelFunction = metaData.labelFunction;
        }

        return axis;
    },

    getDataSet: function (name, data) {
        var dataSetObject = undefined;
        if (util.isDefined(data)) {
            for (var counter = 0; counter < data.length; counter++) {
                var object = data[counter];
                if (util.isDefined(object)) {
                    if (object.name == name) {
                        dataSetObject = object;
                        break;
                    }
                }
            }
        }
        return dataSetObject;
    },

    findGraphByName: function (title, graphSet) {
        var found = undefined;

        graphSet.some(function (graph) {
            if (graph.title == title) {
                found = graph;
                return true;
            }
        });

        return found;
    },

    findGraphByIdInName: function (id, graphSet) {
        var found = undefined;

        graphSet.some(function (graph) {
            if (graph.title.indexOf(id + "_") != -1) {
                found = graph;
                return true;
            }
        });

        return found;
    },

    getAxisByType: function (axisType, axisSet) {
        var found = undefined;
        for (var i = 0; i < axisSet.length; i++) {
            var axis = axisSet[i];
            if (axis.axisType == axisType) {
                found = axis;
                break;
            }
        }
        return found;
    },

    findAxisById: function (id, axisSet) {
        var found;
        for (var i = 0; i < axisSet.length; i++) {
            var axis = axisSet[i];
            if (axis.id == id) {
                found = axis;
                break;
            }
        }
        return found;
    },

    countGraphUsages: function (graphSet, id) {
        var count = 0;
        if (util.isDefined(graphSet)) {
            graphSet.forEach(function (graph) {
                if (graph.valueAxis.id == id) {
                    count++;
                }
            });
        }
        return count;
    },

    excludeDataByID: function (identifier, dataSet) {
        var data = [];
        dataSet.forEach(function (value) {
            if (!util.isDefined(value)) {
                return;
            }
            var dataSetID = value['dataSetID'];
            if (util.isDefined(dataSetID)) {
                if (dataSetID != identifier) {
                    data.push(value);
                }
            }
        });
        return data;
    },

    /**
     * Removes the provided graph from the graphSet by name
     * @param graphName the name of the graph that will be removed (if needed)
     * @param graphSet collection of graph objects
     * @returns true when the graph is found & deleted
     */
    removeGraphByName: function (graphName, graphSet) {
        if (util.isDefined(graphName) && util.isDefined(graphSet)) {
            var existingGraph = module.exports.findGraphByName(graphName, graphSet);
            if (util.isDefined(existingGraph)) {
                graphSet = arrayUtil.removeFrom(graphSet, existingGraph);
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    },

    createGauge: function (percentage, title, ui_id, postfix, invertColors, mininum, maximum) {

        var invertedColors = [
            "#d9534f",
            "#f0ad4e",
            "#47a447"
        ];

        var colors = [
            "#47a447",
            "#f0ad4e",
            "#d9534f"
        ];

        if (util.isDefined(invertColors)) {
            if (invertColors == true) {
                colors = invertedColors;
            }
        }

        return new JustGage({
            id: ui_id,
            value: percentage,
            min: mininum ? mininum : 0,
            max: maximum ? maximum : 100,
            title: title,
            titleFontColor: "white",
            valueFontColor: "white",
            labelFontColor: "white",
            valuePostFix: postfix,
            levelColors: colors

        });
    },

    calculateOffset: function (axisSet, positionFieldName, position, extraOffset) {
        var filteredByPosition = arrayUtil.filterArray(axisSet, positionFieldName, position);
        var currentOffset = 0;
        if (util.isDefined(filteredByPosition)) {
            //A default axis (with position left) is added to the axisSet, therefore ignore this to calculate offset

            if (filteredByPosition.length === 1 && position == 'left' && filteredByPosition[0].id.indexOf("valueAxisAuto") != -1) {
                currentOffset = 0;
            }
            else {
                currentOffset = arrayUtil.getLargest(filteredByPosition, 'offset');
                if (filteredByPosition.length > 0 && currentOffset === 0) {
                    currentOffset += 10;
                }
            }
        }
        return currentOffset === 0 ? 0 : currentOffset + extraOffset;
    },


    createOrRetrieveValueAxis: function (axisType, axisSet, axisId) {
        if (!util.isDefined(axisType) || !util.isDefined(axisSet) || !util.isDefined(axisId)) {
            return null;
        }
        var existingAxis = module.exports.getAxisByType(axisType, axisSet);
        if (util.isDefined(existingAxis))
            return existingAxis;

        var axisMetaData = messageDiscriptors.getAxisMetaByType(axisType);

        if (!util.isDefined(axisMetaData)) {
            //console.log("No axis meta data defined for property: " + axisType)
            return null;
        }

        var newAxis = module.exports.createValueAxis(axisId, 0, axisMetaData);
        newAxis.metaData = axisMetaData;
        newAxis.axisType = axisType;
        return newAxis;
    },

    handleOffsetsForValueAxis: function (axisSet) {
        var filteredByPositionLeft = arrayUtil.filterArray(axisSet, 'position', 'left');
        var filteredByPositionRight = arrayUtil.filterArray(axisSet, 'position', 'right');
        var leftAxisSet = module.exports.changeOffsetsOfArray(filteredByPositionLeft);
        var rightAxisSet = module.exports.changeOffsetsOfArray(filteredByPositionRight);
        var newAxisSet = leftAxisSet.concat(rightAxisSet);
        return newAxisSet;
    },

    changeOffsetsOfArray: function (axisSet) {
        var newAxisSet = [];
        for (var i = 0; i < axisSet.length; i++) {
            if (util.isDefined(axisSet[i].labelsEnabled) && !axisSet[i].labelsEnabled) {
                axisSet[i].offset = 0;
            }
            else if (i == 0) {
                axisSet[i].offset = 0;
            }
            else if (i == 1 && util.isDefined(axisSet[0].id) && axisSet[0].id.indexOf("valueAxisAuto") != -1) {
                axisSet[i].offset = 0;
            }
            else {
                var previousAxisMetaData = messageDiscriptors.getAxisMetaByType(axisSet[i - 1].axisType);
                if (!util.isDefined(previousAxisMetaData)) {
                    return [];
                }
                axisSet[i].offset = axisSet[i - 1].offset + previousAxisMetaData.width;
            }
            newAxisSet.push(axisSet[i]);
        }
        return newAxisSet;
    },


    createSeries: function (data, yAxis, name, formatFunction, property) {
        var newSeries = {
            name: name,
            yAxis: yAxis.options.index,
            data: data,
            lineWidth: 1,
            marker: {
                radius: 3,
                enabled: false
            },
            formatFunction: formatFunction
        };

        if (util.isDefined(property) && util.isDefined(property.dashStyle)) {
            newSeries.dashStyle = property.dashStyle;
        }

        if (util.isDefined(property) && util.isDefined(property.bullet)) {
            newSeries.marker.symbol = property.bullet;
        }
        if (util.isDefined(property) && util.isDefined(property.color)) {
            newSeries.color = property.color;
        }

        return newSeries;
    },

    createYAxis: function (id, color, unit, position, labelsEnabled, labelFunction) {
        var newYAxis = {
            labels: {
                enabled: labelsEnabled,
                formatFunction: labelFunction,
                myunit: unit,
                formatter: function () {
                    var unit = this.axis.options.labels.myunit;
                    var formatFunction = this.axis.options.labels.formatFunction;
                    return formatFunction(this.value, unit);
                },
                style: {
                    color: color
                },
                title: {
                    text: null
                }
            },
            id: id,
            opposite: position == 'left' ? false : true
        };
        return newYAxis;
    },

    findSeries: function (data, name) {
        var found = undefined;
        if (!util.isDefined(data) || data.length == 0) {
            return found;
        }
        data.some(function (serie) {
            if (serie.name == name) {
                found = serie;
                return true;
            }
        });

        return found;
    },

    findYAxis: function (data, id) {
        var found = undefined;
        if (!util.isDefined(data) || data.length == 0) {
            return found;
        }
        data.some(function (yAxis) {
            if (yAxis.options.id == id) {
                found = yAxis;
                return true;
            }
        });
        return found;
    },

    countYAxisUsage: function (data, yAxis) {
        var count = 0;
        if (util.isDefined(data)) {
            data.forEach(function (serie) {
                if (serie.options.yAxis == yAxis) {
                    count++;
                }
            });
        }
        return count;
    },

    createOrRetieveYAxis: function (data, axisType) {
        if (!util.isDefined(axisType) || !util.isDefined(data)) {
            return null;
        }
        var existingAxis = module.exports.findYAxis(data, axisType);
        if (util.isDefined(existingAxis))
            return existingAxis;

        var axisMetaData = messageDiscriptors.getAxisMetaByType(axisType);

        if (!util.isDefined(axisMetaData)) {
            //console.log("No axis meta data defined for property: " + axisType)
            return null;
        }

        var newAxis = module.exports.createValueAxis(axisId, 0, axisMetaData);
        newAxis.metaData = axisMetaData;
        newAxis.axisType = axisType;
        return newAxis;
    },

    toMilesPerHour: function (kmh) {
        return kmh / 1.61;
    },

    extendDataSerie: function (chart, dataset, dataLabel) {
        dataset.forEach(function (value) {
            chart.addSeries($.extend(value, dataLabel));
        });
    },

    isANumber: function (a) {
        return !/[^0-9]/.test(a);
    }
};

